import { Menu, MenuItem, Snackbar, Alert } from "@mui/material";
import React, { useState } from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EditIcon from "@mui/icons-material/Edit";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import { post } from "../../../../utils/api";
import DeleteIcon from "@mui/icons-material/Delete";
import { useUser } from "../../../../context/AuthContext";

const MenuActions = ({
  handleView,
  handleEdit,
  handleDelete,
  anchorEl,
  handleMenuClose,
  id,
  partnerType,
  handleRequestData,
  sendForApproval,
}) => {
  const { user } = useUser();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // success or error

  // Function to handle the "Request Data" POST call

  // Function to close the Snackbar
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: "160px",
            border: "1px solid #ddd",
            marginLeft: "-47px",
          },
        }}
      >
        <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
          <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} /> View
          Info.
        </MenuItem>
        {user?.companyAdmin ? null : (
          <>
            <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
              <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
            </MenuItem>

            <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
              <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
              Delete
            </MenuItem>
            {partnerType === "existing" && sendForApproval === false && (
              <MenuItem onClick={handleRequestData} sx={{ fontSize: "14px" }}>
                <RequestPageIcon
                  sx={{ marginRight: "8px", fontSize: "large" }}
                />
                Send for Approval
              </MenuItem>
            )}
          </>
        )}

        {/* Request Data Button */}
        {/* {partnerType === "existing" && (
          <MenuItem onClick={handleRequestData} sx={{ fontSize: "14px" }}>
            <RequestPageIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
            Request Data
          </MenuItem>
        )} */}
      </Menu>

      {/* Snackbar for displaying success/error messages */}
      <Snackbar
        sx={{ marginTop: "25px" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default MenuActions;
